import { ERP_BASE_URL } from "./endpoints.js";

const getAuthContractUrl = (username) =>
  `${ERP_BASE_URL}/authentication_contracts/authentications_list/${username}`;

const getInstallProtocolUrl = (assignmentId) =>
  `${ERP_BASE_URL}/solicitation_treatments/index/${assignmentId}`;

export { getAuthContractUrl, getInstallProtocolUrl };
